import { format, formatDistance, formatRelative, parseISO, isValid } from 'date-fns';

export const formatDate = (date, formatString = 'MMM dd, yyyy') => {
  if (!date) return '';

  const parsedDate = typeof date === 'string' ? parseISO(date) : date;

  if (!isValid(parsedDate)) return '';

  return format(parsedDate, formatString);
};

export const formatDateTime = (date, formatString = 'MMM dd, yyyy HH:mm') => {
  if (!date) return '';

  const parsedDate = typeof date === 'string' ? parseISO(date) : date;

  if (!isValid(parsedDate)) return '';

  return format(parsedDate, formatString);
};

export const formatTimeAgo = (date) => {
  if (!date) return '';

  const parsedDate = typeof date === 'string' ? parseISO(date) : date;

  if (!isValid(parsedDate)) return '';

  return formatDistance(parsedDate, new Date(), { addSuffix: true });
};

export const formatRelativeDate = (date) => {
  if (!date) return '';

  const parsedDate = typeof date === 'string' ? parseISO(date) : date;

  if (!isValid(parsedDate)) return '';

  return formatRelative(parsedDate, new Date());
};

export const formatShortDate = (date) => {
  return formatDate(date, 'MMM dd');
};

export const formatLongDate = (date) => {
  return formatDate(date, 'EEEE, MMMM dd, yyyy');
};

export const formatTime = (date) => {
  return formatDate(date, 'HH:mm');
};

export const formatTimeWithSeconds = (date) => {
  return formatDate(date, 'HH:mm:ss');
};

export const formatDateForInput = (date) => {
  if (!date) return '';

  const parsedDate = typeof date === 'string' ? parseISO(date) : date;

  if (!isValid(parsedDate)) return '';

  return format(parsedDate, 'yyyy-MM-dd');
};

export const formatDateTimeForInput = (date) => {
  if (!date) return '';

  const parsedDate = typeof date === 'string' ? parseISO(date) : date;

  if (!isValid(parsedDate)) return '';

  return format(parsedDate, "yyyy-MM-dd'T'HH:mm");
};

export const getDurationString = (startDate, endDate) => {
  if (!startDate || !endDate) return '';

  const start = typeof startDate === 'string' ? parseISO(startDate) : startDate;
  const end = typeof endDate === 'string' ? parseISO(endDate) : endDate;

  if (!isValid(start) || !isValid(end)) return '';

  return formatDistance(start, end);
};

export const isToday = (date) => {
  if (!date) return false;

  const parsedDate = typeof date === 'string' ? parseISO(date) : date;

  if (!isValid(parsedDate)) return false;

  const today = new Date();
  return (
    parsedDate.getDate() === today.getDate() &&
    parsedDate.getMonth() === today.getMonth() &&
    parsedDate.getFullYear() === today.getFullYear()
  );
};

export const isYesterday = (date) => {
  if (!date) return false;

  const parsedDate = typeof date === 'string' ? parseISO(date) : date;

  if (!isValid(parsedDate)) return false;

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  return (
    parsedDate.getDate() === yesterday.getDate() &&
    parsedDate.getMonth() === yesterday.getMonth() &&
    parsedDate.getFullYear() === yesterday.getFullYear()
  );
};

export const getDateRangeString = (startDate, endDate) => {
  if (!startDate || !endDate) return '';

  const start = formatDate(startDate, 'MMM dd');
  const end = formatDate(endDate, 'MMM dd, yyyy');

  return `${start} - ${end}`;
};

export default {
  formatDate,
  formatDateTime,
  formatTimeAgo,
  formatRelativeDate,
  formatShortDate,
  formatLongDate,
  formatTime,
  formatTimeWithSeconds,
  formatDateForInput,
  formatDateTimeForInput,
  getDurationString,
  isToday,
  isYesterday,
  getDateRangeString
};